<template>
  <section id="Categoria" class="categorias">
    <h2 class="titulo">📹 Categorías de Cámaras</h2>

    <div class="grid-categorias">
      <div
        v-for="(categoria, index) in categorias"
        :key="index"
        class="card-categoria"
      >
        <img :src="categoria.icono" :alt="categoria.titulo" class="icono" />
        <h3 class="card-titulo">{{ categoria.titulo }}</h3>
        <p class="card-descripcion">{{ categoria.descripcion }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategoriaCamara',
  data() {
    return {
      categorias: [
        {
          titulo: 'Cámaras de Seguridad CCTV',
          icono: require('@/assets/icons/cctv.png'),
          descripcion: 'Instalación y configuración de sistemas de videovigilancia con cámaras analógicas y DVR.'
        },
        {
          titulo: 'Cámaras IP',
          icono: require('@/assets/icons/ipcamera.png'),
          descripcion: 'Monitoreo remoto y configuración de cámaras IP con acceso desde dispositivos móviles y PC.'
        },
        {
          titulo: 'Cámaras PTZ',
          icono: require('@/assets/icons/ptz.png'),
          descripcion: 'Cámaras con movimiento panorámico, zoom y tilt para mayor control de la seguridad.'
        },
        {
          titulo: 'Videograbadores (NVR/DVR)',
          icono: require('@/assets/icons/nvr.png'),
          descripcion: 'Configuración de grabadores digitales y en red para almacenar y gestionar las grabaciones.'
        },
        {
          titulo: 'Control de Acceso',
          icono: require('@/assets/icons/controlacceso.png'),
          descripcion: 'Sistemas de control de puertas, tarjetas RFID y biometría para mayor seguridad.'
        },
        {
          titulo: 'Alarmas y Sensores',
          icono: require('@/assets/icons/alarm.png'),
          descripcion: 'Integración de alarmas, sensores de movimiento y detección de intrusos.'
        },
        {
          titulo: 'Cámaras Inalámbricas',
          icono: require('@/assets/icons/wifi.png'),
          descripcion: 'Soluciones de videovigilancia sin cables, fáciles de instalar y configurar.'
        },
        {
          titulo: 'Video Portero',
          icono: require('@/assets/icons/CámarasOcultas.svg'),
          descripcion: 'Cámaras discretas para monitoreo encubierto en hogares, oficinas y comercios.'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* Mantengo tu mismo estilo */
.categorias {
  background: url('@/assets/Img/Banners/camaras.jpg') no-repeat center center;
  background-size: cover;
  padding: 3rem 2rem;
  color: #fff;
  text-align: center;
}

.titulo {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  animation: fadeInDown 1s ease-in-out;
}

.grid-categorias {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: auto;
}

.card-categoria {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  animation: fadeInUp 1s ease forwards;
}

.card-categoria:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 242, 255, 0.4);
}

.icono {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.card-categoria:hover .icono {
  transform: scale(1.2) rotate(5deg);
}

.card-titulo {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
}

.card-descripcion {
  font-size: 0.95rem;
  text-align: center;
  line-height: 1.4;
}

/* Animaciones */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
